module.exports = __webpack_public_path__ + "img/zrx.5ef86773.svg";